import { Intersect } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { useRelatedQuestions } from 'src/hooks';
import { Message } from 'src/types';
import { Button } from 'src/v2/commonComponents/Button';

type RelatedQuestionsButtonProps = {
  messageId: Message['message_id'];
  payload: Message['payload'];
  disabled?: boolean;
  withTitle?: boolean;
  onClick?: () => void;
};

export const RelatedQuestionsButton = ({
  messageId,
  payload,
  disabled,
  withTitle,
  onClick,
}: RelatedQuestionsButtonProps) => {
  const { onToggleRelatedQuestionsVisibility, getRelatedQuestions } =
    useRelatedQuestions();
  const relatedQuestions = getRelatedQuestions(payload);

  const handleClick = () => {
    if (!messageId) {
      return;
    }

    onToggleRelatedQuestionsVisibility(messageId);
    onClick?.();
  };

  return (
    <Button
      onClick={handleClick}
      disabled={disabled || !messageId || !relatedQuestions?.length}
      size={withTitle ? 'medium' : 'small'}
      shape={withTitle ? 'regular' : 'round'}
      color="transparent"
      fullWidthWithLeftAlign={withTitle}
    >
      <Intersect size={SVG_SIZE_M} />
      {withTitle && 'Related questions'}
    </Button>
  );
};
